module.exports = __webpack_public_path__ + "static/img/flow.c369c93e.jpg";